import { useField } from '@mantine/form'
import { useMemo, useState } from 'react'

import { useGetBenefitsByAbcsQuery } from './benefit.api'

const PAGINATION_LIMIT = 10

const useGetBenefitsByAbcs = (abcIds: string, initialValue = '') => {
  const [page, setPage] = useState(0)
  const search = useField({ initialValue })

  const { data, isError, isLoading, isSuccess, isFetching } =
    useGetBenefitsByAbcsQuery({
      params: {
        abcIds,
        ...(search.getValue()
          ? { search: search.getValue() }
          : {
              limit: PAGINATION_LIMIT,
              offset: page * PAGINATION_LIMIT,
            }),
      },
    })

  const handlePaginate = () => {
    if (isFetching) return
    setPage((prev) => {
      if (
        data &&
        data.totalRecords <= prev * PAGINATION_LIMIT + PAGINATION_LIMIT
      ) {
        return prev
      }
      return prev + 1
    })
  }

  const benefitsOptions = useMemo(() => {
    if (data) {
      return data.records.map(({ id, name }) => ({ value: id!, label: name! }))
    }
  }, [data])

  return {
    benefitsOptions,
    data,
    isError,
    isLoading,
    isFetching,
    isSuccess,
    handlePaginate,
    searchForm: search,
  }
}

export default useGetBenefitsByAbcs
